import React from "react";
import styles from "./InformationCartPage.module.css";

import {
  CartStep,
  CartInformationForm,
  CartTotal,
} from "../../../components/Cart";
import helper from "../../../core/helper/Helper";
import Grid from "@material-ui/core/Grid";
import { RouterName } from "shared/RouterName";
import { useDispatch } from "react-redux";
import { fetchAddInformationCartInLocalStorage } from "redux/ActionCreators/CartActionCreators";

const InformationCartPage = () => {
  const dispatch = useDispatch();

  const handleCompleteCart = (data) => {
    dispatch(fetchAddInformationCartInLocalStorage(data));
    let url = `${RouterName.Payment.Completed.url}`;
    helper.push(url);
  };

  return (
    <section className={styles.section}>
      <div className={styles.item}>
        <CartStep />
      </div>
      <div className={styles.item}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3}>
            <CartTotal />
          </Grid>
          <Grid item xs={12} sm={9}>
            <CartInformationForm handelDataSubmit={handleCompleteCart} />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default InformationCartPage;
